/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedDocumentSelectFilterList200,
  GetApiV1CourseregistrationSharedDocumentSelectFilterList401,
  GetApiV1CourseregistrationSharedDocumentSelectFilterList500,
  GetApiV1CourseregistrationSharedDocumentSelectFilterListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedDocumentSelectFilterList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedDocumentSelectFilterList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentSelectFilterList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedDocumentSelectFilterList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentSelectFilterList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedDocumentSelectFilterList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentSelectFilterList500>;

export const getApiV1CourseregistrationSharedDocumentSelectFilterListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedDocumentSelectFilterList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentSelectFilterListQueryResponse>;
